import { getAuthToken } from "../context/auth-context";
import { CALL_API } from "../context/constValues";
import Swal from "sweetalert2";

export async function getAllOrdenesDePago() {
  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/ordendepago`, {
    headers: { Authorization: "Bearer " + token },
  });

  const data = await response.json();
  if (!response.ok) {
    throw new Error("Can not fetch the data with this parameter");
  }

  return data.ordenes;
}
export async function insertOrdenDePago({ fechainicio, fechafin, descripcion }) {
  const token = getAuthToken();
  try {
    const response = await fetch(`${CALL_API}/ordendepago`, {
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        fechainicio,
        fechafin,
        descripcion,
      }),
    });

    const data = await response.json();
    if (!response.ok) {
      if (response.status === 422) {
        throw new Error("Validation failed, entered data is incorrect.");
      }
      throw new Error(data.message || "No se pudo agregar la orden de pago");
    }

    return data;
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Error",
      text: error.message || "Error al agregar la orden de pago",
    });
    throw error;
  }
}
export async function UpdateORDEN (idordendepago,estado)
{
  const token = getAuthToken();
  try {
    const response = await fetch(`${CALL_API}/updateordendepago/${idordendepago}`, {
      method: "PUT",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        estado
      }),
    });

    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.message || "No se pudo actualizar la orden de pago");
    }

    return data;
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Error",
      text: error.message || "Error al actualizar la orden de pago",
    });
    throw error;
  }
}
export async function getOrdenDePagoById(id) {
  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/ordendepago/${id}`, {
    headers: { Authorization: "Bearer " + token },
  });
  if (!response.ok) {
    throw new Error("Can not fetch the data with this parameter");
  }

  const data = await response.json();
  return data;
}
export async function getLiquidacionByOrdenDePago(idordendepago) {
  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/liquidacionbyorden/${idordendepago}`, {
    headers: { Authorization: "Bearer " + token },
  });

  if (!response.ok) {
    throw new Error("Can not fetch the data with this parameter");
  }

  const data = await response.json();
  return data.liquidaciones;
}
export async function getPagoProveedoresByOrdenDePago(idordendepago) {
  try {
    const token = getAuthToken();
    const response = await fetch(`${CALL_API}/pagoproveedoresbyorden/${idordendepago}`, {
      headers: { Authorization: "Bearer " + token },
    });
    if (!response.ok) {
      // Intenta obtener el mensaje de error del backend si existe
      let errorMsg = "No se pudo obtener los datos de pago de proveedores con este parámetro";
      try {
        const errorData = await response.json();
        if (errorData && errorData.message) {
          errorMsg = errorData.message;
        }
      } catch (_) {
        // Si no se puede parsear el error, usa el mensaje por defecto
      }
      console.error(errorMsg);
      throw new Error(errorMsg);
    }
    const data = await response.json();
 
    return data.pagoProveedores; // <- depende de cómo el backend nombre la propiedad
  } catch (error) {
    console.error("Error en getPagoProveedoresByOrdenDePago:", error);
    throw error;
  }
}
export async function addFacturaProfesional(data) {
  const token = getAuthToken();
  try {
    const response = await fetch(`${CALL_API}/facturasprofesionales`, {
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });

    const result = await response.json();
    if (!response.ok) {
      throw new Error(result.message || "No se pudo agregar la factura");
    }

    return result;
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Error",
      text: error.message || "Error al agregar la factura",
    });
    throw error;
  }
}
export async function updateFacturaProfesional(data) {
  const token = getAuthToken();
  try {
    const response = await fetch(`${CALL_API}/facturasprofesionales/${data.idfactura}`, {
      method: "PUT",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    if (!response.ok) {
      throw new Error(result.message || "No se pudo actualizar la factura");
    }

    return result;
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Error",
      text: error.message || "Error al actualizar la factura",
    });
    throw error;
  }
}
export async function getFacturasProfesionalesByLiq(idusuario, idliquidacion) {
  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/facturasprofesionales/${idusuario}/${idliquidacion}`, {
    headers: { Authorization: "Bearer " + token },
  });
  if (!response.ok) {
    throw new Error("Can not fetch the data with this parameter");
  }
  const data = await response.json();
  return data.facturas;
}
export async function getFacturasbyLiq(idliquidacion){
  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/facturasbyliq/${idliquidacion}`, {
    headers: { Authorization: "Bearer " + token },
  });
  if (!response.ok) {
    throw new Error("Can not fetch the data with this parameter");
  }
  const data = await response.json();
  return data.facturas;
}
export async function addLiquidacionToOrden(idliquidacion,idordendepago,codigo) {
  const token = getAuthToken();
  try {
    const response = await fetch(`${CALL_API}/addliqordendepago`, {
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ idliquidacion, idordendepago, codigo }),
    });
    const result = await response.json();
    if (!response.ok) {
      throw new Error(result.message || "No se pudo agregar  a la orden de pago");
    }

    return result;
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Error",
      text: error.message || "Error al agregar a la orden de pago",
    });
    throw error;
  }
}
export async function removeLiquidacionFromOrden(idliquidacion,codigo){
  const token = getAuthToken();
  try {
    const response = await fetch(`${CALL_API}/removeliqordendepago`, {
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ idliquidacion, codigo }),
    });
    const result = await response.json();
    if (!response.ok) {
      throw new Error(result.message || "No se pudo eliminar de la orden de pago");
    }

    return result;
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Error",
      text: error.message || "Error al eliminar de la orden de pago",
    });
    throw error;
  }
}
export async function cambiarEstadoLiq(idliquidacion,codigo,estado="CIERRE") {
  const token = getAuthToken();
  try {
    const response = await fetch(`${CALL_API}/cambiarEstadoLiq`, {
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ idliquidacion, codigo, estado }),
    });
    const result = await response.json();
    if (!response.ok) {
      throw new Error(result.message || "No se pudo cambiar el estado de la liquidación");
    }

    return result;
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Error",
      text: error.message || "Error al cambiar el estado de la liquidación",
    });
    throw error;
  }
}